<template>
  <BaseCard>
    <div class="folha" v-if="dadosEvento">
      <div slot="header">
        <h3>Dados do Evento</h3>
        <br />
      </div>
      <div>
        <table class="table table-bordered">
          <tr>
            <th class="uppercase">Protocolo</th>
            <td>{{ dadosEvento.protocolo }}</td>
          </tr>
          <tr>
            <th class="uppercase">Tipo do Evento</th>
            <td>{{ dadosEvento.dadosGerais.descricaoTipoEvento }}</td>
          </tr>
          <tr>
            <th class="uppercase">Data do Evento</th>
            <td>{{ dadosEvento.dadosGerais.dataEvento }}</td>
          </tr>
          <tr>
            <th class="uppercase">Data de abertura do Evento</th>
            <td>{{ dadosEvento.createdAt | formatDate }}</td>
          </tr>
          <tr>
            <th class="uppercase">Envolvimento</th>
            <td>{{ dadosEvento.dadosGerais.descricaoEnvolvimento }}</td>
          </tr>
          <tr>
            <th class="uppercase">Número do boletim</th>
            <td>{{ dadosEvento.dadosGerais.numeroBoletim }}</td>
          </tr>
          <tr>
            <th class="uppercase">Endereço do Evento</th>
            <td>
              {{
                dadosEvento.enderecoEvento ? dadosEvento.enderecoEvento.cep : ''
              }}
              -
              {{
                dadosEvento.enderecoEvento
                  ? dadosEvento.enderecoEvento.endereco
                  : ''
              }}
              {{
                dadosEvento.enderecoEvento
                  ? dadosEvento.enderecoEvento.numero
                  : ''
              }}
              {{
                dadosEvento.enderecoEvento
                  ? dadosEvento.enderecoEvento.complemento
                  : ''
              }}
              -
              {{
                dadosEvento.enderecoEvento
                  ? dadosEvento.enderecoEvento.bairro
                  : ''
              }}
              -
              {{
                dadosEvento.enderecoEvento
                  ? dadosEvento.enderecoEvento.cidade
                  : ''
              }}
              /
              {{
                dadosEvento.enderecoEvento
                  ? dadosEvento.enderecoEvento.estado
                  : ''
              }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </BaseCard>
</template>

<script>
import BaseCard from './BaseCard.vue';

export default {
  props: ['dadosEvento'],
  components: {
    BaseCard,
  },
};
</script>
